"use client";

export default function WebsiteError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[50vh] items-center justify-center px-6">
      <div className="text-center space-y-4">
        <h2 className="font-heading text-xl font-bold text-(--fm-text-primary)">
          Something went wrong
        </h2>
        <p className="text-sm text-(--fm-text-secondary)">
          {error.message || "An unexpected error occurred."}
        </p>
        <button
          onClick={reset}
          className="px-4 py-2 rounded-lg bg-(--fm-accent) text-(--fm-background) text-sm font-medium hover:bg-(--fm-accent-hover) transition-colors"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
